import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Select from "react-select";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import RemoveIcon from "../icon/RemoveIcon";
import StyleLink from "../dev/StyleLink";
import Tour from "../reducer/Tour";
class InfoListProposal extends Component {
    state = {
        isPropoaslOpen: window.matchMedia("(min-width: 768px)").matches //手機平板預設關閉
    };
    toggleContainer = () =>
        this.setState({ isPropoaslOpen: !this.state.isPropoaslOpen });
    renderCreators = () => {
        const { selectedCreators } = this.props;
        // const { exsitedCreators } = this.state
        const { exsitedCreators } = this.props;
        const { renderCreator } = this;
        // 分成1.選擇創作者得的到的創作者名單與2.提案已存在創作者名單
        return (
            <CreatorsWrap>
                {renderCreator(selectedCreators, "selectedCreators")}
                {renderCreator(exsitedCreators, "exsitedCreators")}
            </CreatorsWrap>
        );
    };
    renderCreator = (list, condition) => {
        const { selectCreator, selectedCreators } = this.props;
        const { deleteExsitedCreator } = this.props;
        return (
            <TransitionGroup>
                {" "}
                {/* 淡入淡出動畫 */}
                {list.map(({ id, title, avatar }) => (
                    <CSSTransition
                        key={title}
                        timeout={200}
                        classNames="creatorFade"
                    >
                        {/* 動畫效果css放在Container內 */}
                        {condition === "exsitedCreators" &&
                        selectedCreators.find(i => i.id === id) !==
                            undefined ? (
                            <div />
                        ) : (
                            <CreatorWrap>
                                <StyleLink
                                    to={`/Info/${id}`}
                                    target="blank"
                                    title={title}
                                >
                                    <CreatorContent>
                                        <CreatorAvatar avatar={avatar} />
                                        {title}
                                    </CreatorContent>
                                </StyleLink>
                                <CreatorDelete
                                    onClick={() =>
                                        condition === "selectedCreators"
                                            ? selectCreator(id)
                                            : deleteExsitedCreator(id)
                                    }
                                >
                                    <RemoveIcon />
                                </CreatorDelete>
                            </CreatorWrap>
                        )}
                    </CSSTransition>
                ))}
            </TransitionGroup>
        );
    };
    renderControlPart = () => {
        const { selectProposal } = this.props;
        const {
            proposalTitle: { id, title },
            propoaslTitleList,
            proposalSubmit
        } = this.props;
        const { messages, tour: {isInfoListTourActive} } = this.props;
        let { isPropoaslOpen } = this.state;
        isPropoaslOpen = isInfoListTourActive ? true : isPropoaslOpen
        return (
            <ProposalControlWrap title={title}>
                {" "}
                {/* title hover 效果 */}
                <ProposalSelect
                    onChange={selectProposal}
                    options={propoaslTitleList}
                    placeholder={messages.info_list_panel_chose}
                    classNamePrefix="select"
                    theme={theme => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary: "#fff",
                            primary25: "#ccc",
                            primary50: "#666"
                        }
                    })}
                />
                <ProrposalSave
                    onClick={() => proposalSubmit(id)}
                    isPropoaslOpen={isPropoaslOpen}
                >
                    {messages.info_list_panel_save}
                </ProrposalSave>
            </ProposalControlWrap>
        );
    };
    render() {
        const { toggleContainer, renderCreators, renderControlPart } = this;
        const {
            messages,
            resetAllcreators,
            infoListProposalResponse,
            tour:{ isInfoListTourActive }
        } = this.props;
        const inActiveProposalWidth =
            messages.localeLanguage === "zh" ? "100px" : "150px";
        let { isPropoaslOpen } = this.state;
        isPropoaslOpen = isInfoListTourActive ? true : isPropoaslOpen
        return (
            <Container
                id="user_tour_infolist_4"
                isPropoaslOpen={isPropoaslOpen}
                inActiveProposalWidth={inActiveProposalWidth}
            >
                <ProposalTitle isPropoaslOpen={isPropoaslOpen}>
                    <ProposalTitleContent onClick={() => toggleContainer()}>
                        {messages.info_list_panel_title}
                    </ProposalTitleContent>
                    <ResetButton
                        onClick={() => resetAllcreators()}
                        isPropoaslOpen={isPropoaslOpen}
                    >
                        {messages.info_clean_list}
                    </ResetButton>
                </ProposalTitle>
                <BottomPart isPropoaslOpen={isPropoaslOpen}>
                    {renderCreators()}
                    {renderControlPart()}
                    {infoListProposalResponse === "brandCondition" ? (
                        <Response>
                            {messages.info_list_panel_deny}
                            <div
                                onClick={() =>
                                    this.props.history.push("/Pricing")
                                }
                            >
                                {messages.info_list_panel_deny_2}
                            </div>
                        </Response>
                    ) : (
                        <Response>{infoListProposalResponse}</Response>
                    )}
                </BottomPart>
            </Container>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages,
        tour: state.Tour,
    };
};
export default withRouter(connect(mapStateToProps)(InfoListProposal));
const Container = styled.div`
    position: fixed;
    top: calc(72px + 50px);
    right: 0;
    width: ${props =>
        props.isPropoaslOpen ? "250px" : `${props.inActiveProposalWidth}`};
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    transition: all 0.5s ease;
    z-index: 3000;
    .creatorFade-enter {
        height: 0px !important;
        opacity: 0.01;
        color: #fff;
    }
    .creatorFade-enter-active {
        height: 30px !important;
        opacity: 1;
        color: #787878;
        transition: all 0.2s ease-in;
    }
    .creatorFade-exit {
        height: 30px !important;
        color: #787878;
        opacity: 1;
    }
    .creatorFade-exit-active {
        height: 0px !important;
        opacity: 0.01;
        color: #fff;
        transition: all 0.2s ease-in;
    }
`;
const ProposalTitle = styled.div`
    display: flex;
    justify-content: space-between;
    width: auto;
    height: 40px;
    padding: 10px 0;
    padding-left: ${({ isPropoaslOpen }) => (isPropoaslOpen ? "15px" : "10px")};
    background-color: #e94242;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    white-space: nowrap;
    transition: all 0.5s ease;
`;
const ProposalTitleContent = styled.div`
    display: flex;
    cursor: pointer;
`;
const ResetButton = styled.div`
    padding: 0 10px;
    visibility: ${({ isPropoaslOpen }) =>
        isPropoaslOpen ? "visible" : "hidden"};
    color: #fff;
    font-weight: 300;
    font-size: 12px;
    cursor: pointer;
`;
const BottomPart = styled.div`
    position: relative;
    max-height: ${props => (props.isPropoaslOpen ? "240px" : "0")};
    transition: all 0.5s ease;
    overflow: ${props => (props.isPropoaslOpen ? "" : "hidden")};
`;
const CreatorsWrap = styled.div`
    max-height: calc(30px * 8);
    overflow: scroll;
`;
const CreatorWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: auto;
    height: 30px;
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
    transition: all 0.5s ease;
`;
const CreatorContent = styled.div`
    display: flex;
    align-items: center;
    width: 210px;
    padding-left: 16px;
    font-size: 12px;
    color: #787878;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const CreatorAvatar = styled.div`
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border-radius: 100%;
    background: url('${props => props.avatar}');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
`;
const CreatorDelete = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    padding: 16px;
    cursor: pointer;
`;
const ProposalControlWrap = styled.span`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;
    height: 36px;
    background-color: #666666;
`;
const ProrposalSave = styled.div`
    padding: 0 10px;
    color: #fff;
    white-space: nowrap;
    cursor: pointer;
`;
const ProposalSelect = styled(Select)`
    min-width: 160px;
    margin-left: 15px;
    .select__control {
        min-height: 30px;
        border-radius: 0;
        background-color: #666;
    }
    .select__value-container {
        padding: 0 8px;
    }
    .select__dropdown-indicator {
        padding: 0;
    }
    .select__placeholder {
        color: #ccc;
    }
    .select__single-value {
        color: #ccc;
    }
    .select__option--is-selected {
        background-color: #666;
    }
`;
// const ProposalSelect = StyledSelect.extend`
//     margin-left: 15px;
//     min-width: 160px;
//     border: 1px solid #fff;
//     .Select-value {
//         background-color: #666;
//     }
//     .Select-arrow-zone {
//         background-color: #fff;
//     }
//     .Select-control {
//         background-color: #666;
//         & > *:last-child {
//             padding-right: 0;
//         }
//     }
//     .Select-placeholder {
//         background-color: #666;
//     }
//     .Select-menu-outer {
//         max-height: calc(30px * 5.5);
//         overflow: scroll;
//         .Select-option {
//             display: flex;
//             align-items: center;
//             height: 30px;
//             width: 160px;
//             background-color: #666;
//             color: #ccc;
//             font-weight: 300;
//             white-space: nowrap;
//             overflow: hidden;
//             text-overflow: ellipsis;
//             &.is-selected {
//                 background-color: #999;
//             }
//             &.is-focused {
//                 background-color: #999;
//             }
//         }
//     }
// `
const Response = styled.div`
    position: absolute;
    transform: translateY(0%);
    display: flex;
    justify-content: center;
    width: 100%;
    color: #de0606;
    div {
        cursor: pointer;
        text-decoration: underline;
    }
`;



// WEBPACK FOOTER //
// ./src/InfoList/InfoListProposal.js